<script>
export let currentRoute;


import { onMount } from 'svelte';


import Loading from 'components/elements/Loading.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import Form from 'components/forms/views/form/selects-young-guns-sponsorship/Form.svelte';


import SvelteSeo from 'svelte-seo';



let successfully_submitted = false;



const forms_api_url = app_.env.FORMS_API_URL;



</script>


<style>

</style>



<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Young Guns & Selects Sponsorship (2023)
			</p>

		</div>

	</div>
	
</section>


<section class="section skinny-section">

	<div class="container">

		{#if successfully_submitted}

		<MsgCard msg_show={true} msg_text={"Successfully submitted! You can now leave this page."} msg_type={'error'} msg_forever={true} />

		{:else}

		<!-- <MsgCard msg_show={true} msg_text={"Thank you for your support this spring hockey season!<br>If you have any sponsorship inquiries, please contact the office directly."} msg_type={'error'} msg_forever={true} /> -->

		<div class="card form-card" style="margin-bottom: 6rem !important;">

			<div class="card-content">

				<Form bind:successfully_submitted />

			</div>

		</div>

		{/if}

	</div>

</section>







